<template>
  <div class="login">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label prop="account">
        <el-input
          v-if="flag1"
          v-model="ruleForm.account"
          placeholder="手机号"
          inputblur="inputblur"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <el-input
          v-else
          v-model="ruleForm.account"
          placeholder="手机号"
          @blur="getPhonenumber()"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="imageCode">
        <el-input
          v-if="flag2"
          class="code_txt"
          v-model="ruleForm.imageCode"
          placeholder="图形验证码"
          inputblur="inputblur"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <el-input
          v-else
          class="code_txt"
          v-model="ruleForm.imageCode"
          placeholder="图形验证码"
          @blur="getImagecode()"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <div class="img_code" @click="refreshCode">
          <!-- <img src alt /> -->
          <img :src="img" alt />
        </div>
      </el-form-item>
      <el-form-item label prop="telCode">
        <el-input
          v-if="flag3"
          class="code_txt"
          v-model="ruleForm.telCode"
          placeholder="手机验证码"
          inputblur="inputblur"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <el-input
          v-else
          class="code_txt"
          v-model="ruleForm.telCode"
          placeholder="手机验证码"
          @blur="getTelcode()"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <div class="phone_code" @click="disabledButton" v-if="isShow">
          <el-button :disabled="disabled">
            <span>发送验证码</span>
          </el-button>
        </div>
        <div class="phone_code1" v-else>
          <el-button :disabled="disabled">
            <span>{{ timeNum }}</span>
          </el-button>
        </div>
      </el-form-item>
      <el-form-item class="sub_button">
        <el-button
          class="button_login"
          type="primary"
          @click="submitForm('ruleForm')"
          >登录</el-button
        >
      </el-form-item>
      <el-form-item class="clearfix">
        <div class="public_style registration">
          <span>没有账号&nbsp;</span>
          <span @click="pageJump">立即注册</span>
        </div>
        <div class="public_style forget_password" @click="forgetPassword">
          忘记密码
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  // 获取图形验证码
  ApiImagecode,
  // 发送手机验证码
  ApiTelCode,
  ApipasswordLogin,
} from "@/common/js/api.js";

export default {
  name: "PhoneLogin",
  props: ["reset", "towncode"],
  mounted() {
    // 获取图形验证码
    this.getImageCode();
  },
  data() {
    var userphoneRule = (rule, value, callback) => {
      let p =
        /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
      if (!value) {
        this.sendCode = false;
        callback(new Error("手机号格式不正确"));
      } else {
        if (p.test(value) == true) {
          this.sendCode = true;
          callback();
        } else {
          this.sendCode = false;
          callback(new Error("手机号格式不正确"));
        }
      }
    };
    return {
      img: null,
      timeNum: 60,
      timer: null,
      disabled: false,
      isShow: true,
      sendCode: false,
      flag1: false,
      flag2: false,
      flag3: false,
      ruleForm: {
        account: "",
        telCode: "",
        imageCode: "",
        loginType: 1,
        password: "",
      },
      rules: {
        account: [
          { required: true, validator: userphoneRule, trigger: "blur" },
        ],
        signTel: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        imageCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { max: 4, message: "长度为4个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getPhonenumber() {
      this.flag1 = true;
    },
    getImagecode() {
      this.flag2 = true;
    },
    getTelcode() {
      this.flag3 = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async onSubmit() {
      let res = await ApipasswordLogin(this.ruleForm);

      if (res.code == 200) {
        this.$message({
          message: "登录成功",
          type: "success",
        });
        const userInfo = res.result.userInfo;
        this.Cookies.set(
          "legalName",
          userInfo.contactName || userInfo.instition
        );
        this.Cookies.set("institutionName", userInfo.instition);
        this.Cookies.set("identifyCode", userInfo.identifyCode);
        this.Cookies.set("registedType", userInfo.registedType);
        this.Cookies.set("riskToken", res.result.token);
        this.Cookies.set("lastTime", userInfo.recentLoginTime);
        this.setMenu();
      }
    },

    setMenu() {
      const code = this.Cookies.get("identifyCode");

      if (code && code.slice(0, 2) == "WR") {
        this.$router.push("/ReportPlatform/ReportList");
      } else {
        this.$router.push("/UC/User?first=1");
      }
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    pageJump() {
      if (this.towncode) {
        this.$router.push({
          path: "Registered",
          query: {
            TownCode: this.towncode,
          },
        });
      } else {
        this.$confirm("请点击确认跳转首页，选择小镇后再注册", "未选择小镇", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.$router.push({
              path: "/Homepage",
            });
          })
          .catch(() => {
            this.$message({
              type: "warning",
              message: "已取消注册",
            });
          });
      }
    },
    forgetPassword() {
      this.$router.push({
        path: "ResetPassword",
        query: {
          TownCode: this.$route.query.TownCode,
        },
      });
    },
    // 刷新验证码
    refreshCode() {
      this.getImageCode();
    },
    // 获取图形验证码
    getImageCode() {
      ApiImagecode({})
        .then((res) => {
          this.img =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
          // console.log(this.img);
        })
        .catch((res) => {});
    },
    disabledButton() {
      if (this.ruleForm.account && this.sendCode) {
        this.disabled = true;
        this.isShow = false;
        this.timer = setInterval(() => {
          this.timeNum--;
          if (this.timeNum == 0) {
            this.disabled = false;
            this.isShow = true;
            this.timeNum = 60;
            clearInterval(this.timer);
          }
        }, 1000);

        let data = {
          tel: this.ruleForm.account,
        };
        this.getPhoneCode(data);
      }
    },
    getPhoneCode(data) {
      ApiTelCode(data).then((res) => {
        if (res.code == 200) {
          // this.ruleForm.telCode = res.result;
          this.$message({
            message: "验证码发送成功",
            type: "success",
          });
        }
      });
    },
  },
  destroyed() {
    if (this.timer) {
      //如果定时器在运行则关闭
      clearInterval(this.timer);
    }
  },
  watch: {
    reset(val) {
      if (val) {
        this.disabled = false;
        this.isShow = true;
        this.timeNum = 60;
        clearInterval(this.timer);
        this.resetForm("ruleForm");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  form {
    padding-top: 25px;
  }

  ::v-deep  .el-input__inner {
    height: 46px;
    background: #f5f5f5 !important;
  }
  /* 失去焦点改变背景颜色 */
  ::v-deep  .el-input__inner[inputblur="inputblur"] {
    /* background:#E9F0FD; */
    background: #f5f5f5 !important;
  }
  ::v-deep  .el-form-item__content .button_login {
    width: 100%;
    height: 36px;
    border: 0;
    background: #3099fc;
    border-radius: 6px;
  }
  ::v-deep  .el-form-item__content {
    margin-bottom: 24px;
    margin-left: 0 !important;
  }
  ::v-deep  .sub_button .el-form-item__content {
    margin-bottom: 10px !important;
    margin-top: 10px;
  }
}
.public_style {
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  color: #3165ff;
}
.registration span:nth-child(1) {
  color: #b6bcc2;
  cursor: default;
}
.forget_password {
  float: right;
}
.code_txt {
  width: calc(100% - 100px - 10px);
}
.img_code {
  cursor: pointer;
  width: 100px;
  float: right;
  border: 1px solid #ccc;
}
.phone_code ::v-deep  .el-button,
.phone_code1 ::v-deep  .el-button {
  width: 100%;
  height: 46px;
  padding-left: 0 !important;
  text-align: center;
  padding-right: 0 !important;
  color: #3165ff;
  border-radius: 4px;
  border: 1px solid #3165ff;
}
.phone_code1 ::v-deep  .el-button {
  color: #ccc;
  border: 1px solid #ccc;
}
.phone_code,
.phone_code1 {
  cursor: pointer;
  width: 100px;
  height: 36px;
  line-height: 36px;
  float: right;
  font-size: 14px;
  color: #3165ff;
}
</style>